import clsx from "clsx";
import { useTranslation } from "react-i18next";

export default function SolutionSection() {
  const { t, i18n } = useTranslation();
  const isZh = i18n.language === "zh";

  return (
    <div className="relative w-full bg-[#f2f4f6] py-10 md:py-[60px]">
      <div className="max-w-[1200px] mx-auto px-4 md:px-5">
        <h2
          data-aos-delay="100"
          data-aos="fade-up"
          className="font-bold text-[#222] text-[26px] md:text-[34px] text-center pb-[16px] md:pb-[20px] leading-tight"
        >
          {t("home.solution.title")}
        </h2>
        <p data-aos="fade-up" className="text-center text-[#666] text-[15px] md:text-[18px] leading-relaxed px-2">
          {t("home.solution.subtitle")}
        </p>
        <div className="pt-8 md:pt-[60px] relative md:mt-[40px] flex flex-col lg:flex-row gap-5 lg:gap-[2%]">
          {/* 左图卡片 */}
          <div
            data-aos="flip-right"
            data-aos-delay="600"
            className="relative w-full lg:w-1/3 h-[280px] sm:h-[360px] lg:h-[500px] bg-no-repeat bg-cover"
            style={{ backgroundImage: "url(images/index09.jpg)" }}
          >
            <div
              className="bg-white p-5 md:p-[30px] font-bold absolute top-4 left-4 right-4 md:-top-[62px] md:left-0 md:right-auto"
              data-aos="fade-down"
              data-aos-anchor-placement="center-center"
            >
              <h3 className="text-[20px] md:text-[24px] text-[#222] text-left font-bold pb-[10px]">
                {t("home.solution.card1.title")}
              </h3>
              <p className="text-[#0f5f95] text-[16px] md:text-[20px] text-left font-bold leading-[24px]">
                {t("home.solution.card1.subtitle")}
              </p>
            </div>
          </div>
          {/* 中图卡片 */}
          <div
            className="w-full lg:w-1/3 h-[220px] sm:h-[320px] lg:h-[500px] bg-no-repeat bg-cover"
            data-aos="flip-down"
            style={{ backgroundImage: "url(images/index10.jpg)" }}
          ></div>
          {/* 右侧数据卡片 */}
          <div
            data-aos="flip-right"
            className="bg-white p-5 md:p-[30px] w-full lg:w-1/3 relative"
          >
            <div
              className="bg-[#0f5f95] relative lg:absolute lg:-top-[62px] lg:right-0 w-full lg:w-[610px] px-5 py-6 md:pl-[145px] md:h-[180px] text-white flex flex-col md:grid md:place-content-center gap-4"
              data-aos="fade-up"
            >
              <div className="relative mx-auto md:absolute md:left-[30px] md:top-[30px] md:mx-0 box-border w-[100px] h-[100px] md:w-[123px] md:h-[123px] md:rotate-130 md:origin-center">
                <div className="w-[88px] h-[88px] md:w-[107px] md:h-[107px] rounded-full absolute border-8 border-[#1674b4] m-auto inset-0 box-border"></div>
                <div
                  className="w-[88px] h-[88px] md:w-[107px] md:h-[107px] rounded-full absolute border-8 border-[#feca5c] m-auto inset-0 box-border"
                  style={{ borderBottomColor: "transparent" }}
                ></div>
                <div className="w-full h-full md:w-[123px] md:h-[123px] text-center flex items-center justify-center absolute left-0 top-0 md:-rotate-130 md:origin-center text-[#feca5c] text-[28px] md:text-[32px] font-[Arial] font-bold">
                  {t("home.solution.card2.percentage")}
                </div>
              </div>
              <div>
                <h3
                  className="w-full md:w-[400px] leading-[28px] text-[16px] md:text-[20px] text-white mb-4 font-semibold text-center md:text-left"
                  dangerouslySetInnerHTML={{
                    __html: t("home.solution.card2.title").replace(
                      t("home.solution.card2.percentage"),
                      `<i>${t("home.solution.card2.percentage")}</i>`
                    ),
                  }}
                />
                <span className="w-full flex flex-wrap items-center justify-center md:justify-start gap-3 md:gap-4">
                  <img src="images/index05.jpg" alt="Call Center" className="h-8 w-auto" />
                  <img src="images/index06.jpg" alt="Email Support" className="h-8 w-auto" />
                  <img src="images/index07.jpg" alt="Social Media Support" className="h-8 w-auto" />
                  <img src="images/index08.jpg" alt="Customer Support" className="h-8 w-auto" />
                </span>
              </div>
            </div>
            <p
              className={clsx(
                isZh ? "leading-[30px]" : "leading-[25px]",
                "pt-6 lg:pt-[140px] text-[#222] text-left text-[15px] md:text-[16px]",
                isZh ? "whitespace-pre-line" : ""
              )}
              data-aos-delay="500"
              data-aos="zoom-in-up"
            >
              {t("home.solution.card2.description")}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
